import { createApp } from 'vue';
import App from './App.vue';
import { initPlugins } from '@/core/plugins';
import '@/core/plugins/auth';
import { useYandexMetrika } from '@/core/composables/useYandexMetrika';

const app = createApp(App);

app.provide('extranetApp', app);

initPlugins(app);

const { init: initYandexMetrika } = useYandexMetrika();
initYandexMetrika();

app.mount('#app');
